module.exports = __webpack_public_path__ + "static/media/RBI.7d3b3ee1.svg";